/* eslint-disable @nrwl/nx/enforce-module-boundaries */
/**
 * 名片相关 api
 */
import type { ApiResult } from '../apis.d';
import { API_PREFIX } from '@shared/config';
import { httpClient } from '@shared/utils';
import type {
  BusinessCardGetRequest,
  BusinessCardGetResponse,
} from '@shared/types/httpTypes/applet/business_card/get_get';
import type {
  StaffCardGetCertificateGroupRequest,
  StaffCardGetCertificateGroupResponse,
} from '@shared/types/httpTypes/applet/staffCard/getCertificateGroup_get';
import type {
  StationCardHasLocalizationCertificateRequest,
  StationCardHasLocalizationCertificateResponse,
} from '@shared/types/httpTypes/applet/station_card/hasLocalizationCertificate_get';
import type { ConfigGetRequest, ConfigGetResponse } from '@shared/types/httpTypes/applet/business_card/config/get_get';
import type { ConfigSaveRequest } from '@shared/types/httpTypes/applet/business_card/config/save_post';

/**
 * 获取客户经理名片信息
 * https://yapi.tengmoney.com/project/13/interface/api/21793
 */
export const getBusinessCardInfoApi = async (
  params?: BusinessCardGetRequest
): Promise<ApiResult<Required<BusinessCardGetResponse['retdata']>>> =>
  await httpClient.get(`${API_PREFIX}api/applet/business_card/get`, {
    params,
  });

/**
 * 获取经理组合证书列表
 */
export const getCertificateGroup = async (
  params: StaffCardGetCertificateGroupRequest
): Promise<ApiResult<StaffCardGetCertificateGroupResponse['retdata']>> => {
  return await httpClient.get('/caizhi_miniapi/api/applet/staffCard/getCertificateGroup', {
    params,
  });
};

/**
 * 判断员工是否有本地化证书
 */
export const getLocalizationCertificate = async (
  params: StationCardHasLocalizationCertificateRequest
): Promise<ApiResult<StationCardHasLocalizationCertificateResponse['retdata']>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/station_card/hasLocalizationCertificate`, {
    params,
  });
};

export const getBusinessCardConfig = async (
  params: ConfigGetRequest
): Promise<ApiResult<ConfigGetResponse['retdata']>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/business_card/config/get`, {
    params,
  });
};

export const saveBusinessCardConfig = async (params: ConfigSaveRequest) => {
  return await httpClient.post(`${API_PREFIX}api/applet/business_card/config/save`, params);
};

/**
 * 更新、新建经理个人标签
 */
export const updatePersonalTag = async (params: string[]): Promise<void> => {
  return await httpClient.post('/caizhi_miniapi/api/applet/business_card/tag/update', params);
};
